export type ProfileBootstrapStatus = "loading" | "ready" | "access-denied" | "failed";

export const PROFILE_BOOTSTRAP_RETRY_DELAYS_MS = [1000, 2000, 4000, 8000] as const;

function errorText(error: any): string {
  const payload = error?.response?.data;
  return [
    payload?.error_code,
    payload?.error,
    payload?.message,
    ...(Array.isArray(payload?.errors) ? payload.errors : []),
    error?.message,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function classifyProfileBootstrapError(error: any): Exclude<ProfileBootstrapStatus, "loading" | "ready"> {
  const status = Number(error?.response?.status ?? error?.status ?? 0);
  const message = errorText(error);
  if (
    status === 403 ||
    /\bno role\b|\brole (?:is )?not assigned\b|\baccess denied\b/.test(message)
  ) {
    return "access-denied";
  }
  return "failed";
}

export function shouldRetryProfileBootstrapError(error: any): boolean {
  if (classifyProfileBootstrapError(error) === "access-denied") return false;
  const status = Number(error?.response?.status ?? error?.status ?? 0);
  const errorCode = String(error?.response?.data?.error_code ?? "").toUpperCase();
  return (
    status === 0 ||
    status === 408 ||
    status === 425 ||
    status === 429 ||
    status >= 500 ||
    errorCode === "AUTH_DEPENDENCY_UNAVAILABLE"
  );
}
